import { XMarkIcon } from '@heroicons/react/20/solid';
import { useSlideOver } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

type AccessGrantSlideOverHeaderProperties = {
  slideOverId: string;
};

export function AccessGrantSlideOverHeader({
  slideOverId,
}: AccessGrantSlideOverHeaderProperties) {
  const { t } = useTranslation('accessGrants');
  const { deleteSlideOver } = useSlideOver();
  // Matches the shared slide-over header in container-interface's ContextualView.
  return (
    <div className="border-dark-gray border-b">
      <div className="bg-lightest-gray p-15px flex min-w-0 items-center gap-3">
        <button
          aria-label={t('closeGrantDetails')}
          className="focus-visible:ring-plerion-burnt-violet-alternate focus-visible:ring-offset-lightest-gray inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 dark:focus-visible:ring-white"
          data-testid="close-grant-slide-over"
          onClick={() => deleteSlideOver(slideOverId)}
          type="button"
        >
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <h1
          title={t('accessGrantDetails')}
          className="line-clamp-2 text-lg break-words text-gray-900 dark:text-gray-100"
        >
          {t('accessGrantDetails')}
        </h1>
      </div>
    </div>
  );
}
